import { useAuth } from '../store/AuthContext';

export const MODULES = [
  'dashboard', 'customers', 'leads', 'bookings', 'quotes', 'invoices', 'packages',
  'agents', 'users', 'vendors', 'purchases', 'accounting', 'documents',
  'tasks', 'expenses', 'reports', 'settings',
];
export const ACTIONS = ['view', 'add', 'edit', 'delete'];

export const MODULE_LABELS = {
  dashboard: 'Dashboard',
  customers: 'Customers',
  leads: 'Leads',
  bookings: 'Invoices (Bookings)',
  quotes: 'Quotes',
  invoices: 'Sales Invoices',
  packages: 'Packages',
  agents: 'Agents & Team',
  users: 'Users & Roles',
  vendors: 'Vendors',
  purchases: 'Purchases',
  accounting: 'Accounting',
  documents: 'Documents',
  tasks: 'Tasks',
  expenses: 'Expenses',
  reports: 'Reports',
  settings: 'Settings',
};

export const getPermission = (user, module, action = 'view') => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const p = user.permissions && user.permissions[module];
  return Boolean(p && p[action]);
};

export const useCan = (module, action = 'view') => {
  const { user } = useAuth();
  return getPermission(user, module, action);
};

export const Can = ({ module, action = 'view', children, fallback = null }) => {
  const ok = useCan(module, action);
  return ok ? children : fallback;
};
